// Generated by purs version 0.14.3
"use strict";
var Control_Applicative = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Applicative.purs");
var Data_Argonaut_Core = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/argonaut-core/v6.0.0/src/Data/Argonaut/Core.purs");
var Data_Bifunctor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/bifunctors/v5.0.0/src/Data/Bifunctor.purs");
var Data_Boolean = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Boolean.purs");
var Data_Codec = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/codec/v4.0.1/src/Data/Codec.purs");
var Data_Codec_Argonaut = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/codec-argonaut/v8.0.0/src/Data/Codec/Argonaut.purs");
var Data_Codec_Argonaut_Common = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/codec-argonaut/v8.0.0/src/Data/Codec/Argonaut/Common.purs");
var Data_Either = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/either/v5.0.0/src/Data/Either.purs");
var Data_Foldable = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foldable-traversable/v5.0.1/src/Data/Foldable.purs");
var Data_Functor = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Data/Functor.purs");
var Data_Maybe = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/maybe/v5.0.0/src/Data/Maybe.purs");
var Data_Traversable = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foldable-traversable/v5.0.1/src/Data/Traversable.purs");
var Data_Tuple = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/tuples/v6.0.1/src/Data/Tuple.purs");
var Data_Unfoldable = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/unfoldable/v5.0.0/src/Data/Unfoldable.purs");
var Foreign_Object = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/foreign-object/v3.0.0/src/Foreign/Object.purs");
var maybe = function (codec) {
    var enc = function (v) {
        if (v instanceof Data_Maybe.Nothing) {
            return Data_Argonaut_Core.jsonNull;
        };
        if (v instanceof Data_Maybe.Just) {
            return Data_Codec.encode(codec)(v.value0);
        };
        throw new Error("Failed pattern match at Data.Codec.Argonaut.Compat (line 36, column 9 - line 38, column 28): " + [ v.constructor.name ]);
    };
    var dec = function (j) {
        if (Data_Argonaut_Core.isNull(j)) {
            return Control_Applicative.pure(Data_Either.applicativeEither)(Data_Maybe.Nothing.value);
        };
        if (Data_Boolean.otherwise) {
            return Data_Bifunctor.bimap(Data_Bifunctor.bifunctorEither)(Data_Codec_Argonaut.Named.create("Maybe"))(Data_Maybe.Just.create)(Data_Codec.decode(codec)(j));
        };
        throw new Error("Failed pattern match at Data.Codec.Argonaut.Compat (line 31, column 3 - line 31, column 50): " + [ j.constructor.name ]);
    };
    return Data_Codec.basicCodec(dec)(enc);
};
var foreignObject = function (codec) {
    var fromArray = Foreign_Object.fromFoldable(Data_Foldable.foldableArray);
    var decodeItem = function (v) {
        return Data_Bifunctor.bimap(Data_Bifunctor.bifunctorEither)(Data_Codec_Argonaut.AtKey.create(v.value0))(Data_Tuple.Tuple.create(v.value0))(Data_Codec.decode(codec)(v.value1));
    };
    return Data_Codec.mapCodec(Data_Either.bindEither)((function () {
        var $8 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Codec_Argonaut.Named.create("StrMap"));
        var $9 = Data_Functor.map(Data_Either.functorEither)(fromArray);
        var $10 = Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Either.applicativeEither)(decodeItem);
        var $11 = Foreign_Object.toUnfoldable(Data_Unfoldable.unfoldableArray);
        return function ($12) {
            return $8($9($10($11($12))));
        };
    })())(Data_Functor.map(Foreign_Object.functorObject)(Data_Codec.encode(codec)))(Data_Codec_Argonaut.jobject);
};
module.exports = {
    foreignObject: foreignObject,
    maybe: maybe,
    AtIndex: Data_Codec_Argonaut.AtIndex,
    AtKey: Data_Codec_Argonaut.AtKey,
    MissingValue: Data_Codec_Argonaut.MissingValue,
    Named: Data_Codec_Argonaut.Named,
    TypeMismatch: Data_Codec_Argonaut.TypeMismatch,
    UnexpectedValue: Data_Codec_Argonaut.UnexpectedValue,
    array: Data_Codec_Argonaut.array,
    "boolean": Data_Codec_Argonaut["boolean"],
    "char": Data_Codec_Argonaut["char"],
    decode: Data_Codec_Argonaut.decode,
    encode: Data_Codec_Argonaut.encode,
    fix: Data_Codec_Argonaut.fix,
    index: Data_Codec_Argonaut.index,
    indexedArray: Data_Codec_Argonaut.indexedArray,
    "int": Data_Codec_Argonaut["int"],
    jarray: Data_Codec_Argonaut.jarray,
    jobject: Data_Codec_Argonaut.jobject,
    json: Data_Codec_Argonaut.json,
    "null": Data_Codec_Argonaut["null"],
    number: Data_Codec_Argonaut.number,
    object: Data_Codec_Argonaut.object,
    printJsonDecodeError: Data_Codec_Argonaut.printJsonDecodeError,
    prop: Data_Codec_Argonaut.prop,
    record: Data_Codec_Argonaut.record,
    recordProp: Data_Codec_Argonaut.recordProp,
    string: Data_Codec_Argonaut.string,
    either: Data_Codec_Argonaut_Common.either,
    list: Data_Codec_Argonaut_Common.list,
    map: Data_Codec_Argonaut_Common.map,
    tuple: Data_Codec_Argonaut_Common.tuple
};

